import { BaseProvider } from '@telus-uds/components-web';
import alliumTheme from '@telus-uds/theme-allium';
import React from 'react';
import LocaleContextProvider from './components/context/LocaleContext';
import LocalizedStringsContextProvider from './components/context/LocalizedStringsContext';
import TranslationsProvider from './components/context/TranslationsContext';
import ErrorBoundary from './components/errorBoundary';
import Routes from './components/routes';
import SessionTimeout from './helpers/session-timeout';

const App = () => {
  return (
    <BaseProvider defaultTheme={alliumTheme}>
      <LocaleContextProvider>
        <LocalizedStringsContextProvider>
          <ErrorBoundary>
            <TranslationsProvider>
              <SessionTimeout>
                <Routes />
              </SessionTimeout>
            </TranslationsProvider>
          </ErrorBoundary>
        </LocalizedStringsContextProvider>
      </LocaleContextProvider>
    </BaseProvider>
  );
};

export default App;
